var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2111_31657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2111_31657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41246 3.00171L21.3813 19.9705L21.3831 19.9688L21.3848 19.9705L19.9706 21.3847L16.6137 18.0279C15.3568 18.6141 13.8332 19 12 19C4.408 19 2.12632 12.383 2.10444 12.316L2 12L2.10543 11.684C2.11863 11.6416 3.03404 8.98538 5.62047 7.03464L3 4.41417L4.41246 3.00171ZM15.0867 16.5009L13.2895 14.7036C12.8976 14.8933 12.4599 15 12 15C10.358 15 9 13.642 9 12C9 11.5401 9.10665 11.1024 9.29631 10.7105L7.03632 8.45049C5.26898 9.66588 4.41537 11.3097 4.11657 12C4.61587 13.154 6.67774 17 12 17C13.184 17 14.2067 16.8096 15.0867 16.5009ZM12 4.99996C19.592 4.99996 21.8737 11.617 21.8956 11.684L22 12L21.8946 12.316C21.8843 12.349 21.3248 13.9731 19.8511 15.6119L18.4594 14.2202C19.2458 13.3296 19.6859 12.4563 19.8834 12C19.3841 10.846 17.3223 6.99996 12 6.99996C11.7475 6.99996 11.5024 7.00861 11.2644 7.02522L9.50022 5.26104C10.2611 5.09448 11.0926 4.99996 12 4.99996Z",
    fill: "#0E1D31"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.0be15de7.svg";
export { ForwardRef as ReactComponent };